export const translations = {
  en: {
    appTitle: "Alimos Telematics",
    trackerTitle: "Real-time Tracker",
    trackerDesc: "Select a route below to view live arrival times and current bus positions.",
    availableRoutes: "Available Routes",
    active: "Active",
    inactive: "Inactive",
    arrivalTimes: "Arrival Times",
    liveGps: "LIVE GPS ACTIVE",
    connecting: "CONNECTING...",
    stopName: "Stop Name",
    eta: "ETA",
    waitingUpdates: "Waiting for live updates...",
    realTimeInfo: "Real-time Information",
    infoDesc: "The map shows live positions for {route}. The green highlight indicates the current bus position.",
    back: "Back",
    tuesdayNote: "Tuesday Special Route",
    saturdayNote: "Saturday Weekend Route",
    line10Desc: "Main City Circular - North",
    line20Desc: "Coastal Express - South",
    monSat: "Mon - Sat",
    monFri: "Mon - Fri",
    exitTitle: "Exit Application",
    exitConfirm: "Are you sure you want to exit the Alimos Telematics app?",
    exitYes: "Exit Now",
    exitNo: "Stay",
    outOfService: "Out of Service"
  },
  el: {
    appTitle: "Alimos Telematics",
    trackerTitle: "Ζωντανή Παρακολούθηση",
    trackerDesc: "Επιλέξτε μια διαδρομή για να δείτε ζωντανά τις ώρες άφιξης και τη θέση των λεωφορείων.",
    availableRoutes: "Διαθέσιμες Διαδρομές",
    active: "Ενεργό",
    inactive: "Ανενεργό",
    arrivalTimes: "Ώρες Άφιξης",
    liveGps: "ΖΩΝΤΑΝΟ GPS",
    connecting: "ΣΥΝΔΕΣΗ...",
    stopName: "Όνομα Στάσης",
    eta: "Άφιξη",
    waitingUpdates: "Αναμονή για ενημερώσεις...",
    realTimeInfo: "Πληροφορίες Πραγματικού Χρόνου",
    infoDesc: "Ο χάρτης δείχνει τη ζωντανή θέση για το {route}. Η πράσινη επισήμανση δείχνει την τρέσουσα στάση.",
    back: "Πίσω",
    tuesdayNote: "Ειδικό Δρομολόγιο Τρίτης",
    saturdayNote: "Σαββατιανό Δρομολόγιο",
    line10Desc: "Κεντρική Κυκλική - Βόρεια",
    line20Desc: "Παραλιακή Εξπρές - Νότια",
    monSat: "Δευ - Σαβ",
    monFri: "Δευ - Παρ",
    exitTitle: "Έξοδος από την Εφαρμογή",
    exitConfirm: "Είστε σίγουροι ότι θέλετε να βγείτε από την εφαρμογή Alimos Telematics;",
    exitYes: "Έξοδος",
    exitNo: "Παραμονή",
    outOfService: "Εκτός Λειτουργίας"
  }
};